import { MediaMetadata } from '@/types/storage';

export const PRESET_EFFECTS: MediaMetadata[] = [
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/026_띠딩2.mp3",
    "storageType": "url",
    "fileName": "026_띠딩2.mp3",
    "fileSize": 20930,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/028_예~YEAH!.mp3",
    "storageType": "url",
    "fileName": "028_예~YEAH!.mp3",
    "fileSize": 54587,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/032_뾰로롱 마법.WAV",
    "storageType": "url",
    "fileName": "032_뾰로롱 마법.WAV",
    "fileSize": 46164,
    "mimeType": "audio/wav",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/038_뿅.mp3",
    "storageType": "url",
    "fileName": "038_뿅.mp3",
    "fileSize": 1914,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/050_철컥띵 (캐셔).mp3",
    "storageType": "url",
    "fileName": "050_철컥띵 (캐셔).mp3",
    "fileSize": 64328,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/056_띠동띠동(물음표).mp3",
    "storageType": "url",
    "fileName": "056_띠동띠동(물음표).mp3",
    "fileSize": 48945,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/061_뾰로로롱 (하프).mp3",
    "storageType": "url",
    "fileName": "061_뾰로로롱 (하프).mp3",
    "fileSize": 91220,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/094_헉.wav",
    "storageType": "url",
    "fileName": "094_헉.wav",
    "fileSize": 201824,
    "mimeType": "audio/wav",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/1. 꽥.mp3",
    "storageType": "url",
    "fileName": "1. 꽥.mp3",
    "fileSize": 1913,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/10. 띠용.mp3",
    "storageType": "url",
    "fileName": "10. 띠용.mp3",
    "fileSize": 7555,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/12. 뿌직.mp3",
    "storageType": "url",
    "fileName": "12. 뿌직.mp3",
    "fileSize": 4421,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/13. 명중.mp3",
    "storageType": "url",
    "fileName": "13. 명중.mp3",
    "fileSize": 10690,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/14. 샷건.mp3",
    "storageType": "url",
    "fileName": "14. 샷건.mp3",
    "fileSize": 10690,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/15. 어엉.mp3",
    "storageType": "url",
    "fileName": "15. 어엉.mp3",
    "fileSize": 9436,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/16. 유성.mp3",
    "storageType": "url",
    "fileName": "16. 유성.mp3",
    "fileSize": 9123,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/17. 펀치.mp3",
    "storageType": "url",
    "fileName": "17. 펀치.mp3",
    "fileSize": 2853,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/18. X파일.mp3",
    "storageType": "url",
    "fileName": "18. X파일.mp3",
    "fileSize": 52695,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/19. 뽀옥.mp3",
    "storageType": "url",
    "fileName": "19. 뽀옥.mp3",
    "fileSize": 3794,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/2. 러버덕.mp3",
    "storageType": "url",
    "fileName": "2. 러버덕.mp3",
    "fileSize": 4421,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/20. 되감기.mp3",
    "storageType": "url",
    "fileName": "20. 되감기.mp3",
    "fileSize": 7869,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/21. 되감기2.mp3",
    "storageType": "url",
    "fileName": "21. 되감기2.mp3",
    "fileSize": 13511,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/22. 빨리감기.mp3",
    "storageType": "url",
    "fileName": "22. 빨리감기.mp3",
    "fileSize": 7555,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/23. 뚝배기.mp3",
    "storageType": "url",
    "fileName": "23. 뚝배기.mp3",
    "fileSize": 9436,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/24. 빗나감.mp3",
    "storageType": "url",
    "fileName": "24. 빗나감.mp3",
    "fileSize": 2853,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/25. 쨍그랑.mp3",
    "storageType": "url",
    "fileName": "25. 쨍그랑.mp3",
    "fileSize": 13511,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/26. 폭발음.mp3",
    "storageType": "url",
    "fileName": "26. 폭발음.mp3",
    "fileSize": 11944,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/27. 마리오동전.mp3",
    "storageType": "url",
    "fileName": "27. 마리오동전.mp3",
    "fileSize": 10690,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/28. 띠링.mp3",
    "storageType": "url",
    "fileName": "28. 띠링.mp3",
    "fileSize": 8496,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/3. 삑~.mp3",
    "storageType": "url",
    "fileName": "3. 삑~.mp3",
    "fileSize": 3480,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/30. 긴장공포.mp3",
    "storageType": "url",
    "fileName": "30. 긴장공포.mp3",
    "fileSize": 33260,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/31. 물음표.mp3",
    "storageType": "url",
    "fileName": "31. 물음표.mp3",
    "fileSize": 8496,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/32. 느낌표.mp3",
    "storageType": "url",
    "fileName": "32. 느낌표.mp3",
    "fileSize": 7555,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/33. 브레이크.mp3",
    "storageType": "url",
    "fileName": "33. 브레이크.mp3",
    "fileSize": 11317,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/34. 아아악!.mp3",
    "storageType": "url",
    "fileName": "34. 아아악!.mp3",
    "fileSize": 16959,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/35. 남자비명.mp3",
    "storageType": "url",
    "fileName": "35. 남자비명.mp3",
    "fileSize": 7869,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/36. 여자비명.mp3",
    "storageType": "url",
    "fileName": "36. 여자비명.mp3",
    "fileSize": 5048,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/37. 슬픈음악.mp3",
    "storageType": "url",
    "fileName": "37. 슬픈음악.mp3",
    "fileSize": 47993,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/38. 서스펜스.mp3",
    "storageType": "url",
    "fileName": "38. 서스펜스.mp3",
    "fileSize": 7555,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/39. 아기울음.mp3",
    "storageType": "url",
    "fileName": "39. 아기울음.mp3",
    "fileSize": 30125,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/4. 삐삑.mp3",
    "storageType": "url",
    "fileName": "4. 삐삑.mp3",
    "fileSize": 5361,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/40. 두둥액션.mp3",
    "storageType": "url",
    "fileName": "40. 두둥액션.mp3",
    "fileSize": 62099,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/41. 심장소리.mp3",
    "storageType": "url",
    "fileName": "41. 심장소리.mp3",
    "fileSize": 105671,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/42. 엠뷸란스.mp3",
    "storageType": "url",
    "fileName": "42. 엠뷸란스.mp3",
    "fileSize": 43918,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/43. 놀라는배경음.mp3",
    "storageType": "url",
    "fileName": "43. 놀라는배경음.mp3",
    "fileSize": 29498,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/44. 다급한브금.mp3",
    "storageType": "url",
    "fileName": "44. 다급한브금.mp3",
    "fileSize": 132316,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/45. 한입.mp3",
    "storageType": "url",
    "fileName": "45. 한입.mp3",
    "fileSize": 3480,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/5. 까꿍.mp3",
    "storageType": "url",
    "fileName": "5. 까꿍.mp3",
    "fileSize": 9123,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/50. 안녕하세요.mp3",
    "storageType": "url",
    "fileName": "50. 안녕하세요.mp3",
    "fileSize": 11317,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/51. 스핀.mp3",
    "storageType": "url",
    "fileName": "51. 스핀.mp3",
    "fileSize": 27617,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/52. 사악한웃음.mp3",
    "storageType": "url",
    "fileName": "52. 사악한웃음.mp3",
    "fileSize": 14765,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/53. 먼개소리야.mp3",
    "storageType": "url",
    "fileName": "53. 먼개소리야.mp3",
    "fileSize": 19154,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/54. 도망가는소리.mp3",
    "storageType": "url",
    "fileName": "54. 도망가는소리.mp3",
    "fileSize": 11944,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/55. 어이없는웃음.mp3",
    "storageType": "url",
    "fileName": "55. 어이없는웃음.mp3",
    "fileSize": 67428,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/56. 어이없는웃음2.mp3",
    "storageType": "url",
    "fileName": "56. 어이없는웃음2.mp3",
    "fileSize": 22288,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/57. 얄미운줄행랑.mp3",
    "storageType": "url",
    "fileName": "57. 얄미운줄행랑.mp3",
    "fileSize": 16959,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/58. 서프라이즈.mp3",
    "storageType": "url",
    "fileName": "58. 서프라이즈.mp3",
    "fileSize": 7555,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/59. 대쉬.mp3",
    "storageType": "url",
    "fileName": "59. 대쉬.mp3",
    "fileSize": 7869,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/6. 놉.mp3",
    "storageType": "url",
    "fileName": "6. 놉.mp3",
    "fileSize": 11317,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/60. 넌못지나간다.mp3",
    "storageType": "url",
    "fileName": "60. 넌못지나간다.mp3",
    "fileSize": 24796,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/61. 히잉.mp3",
    "storageType": "url",
    "fileName": "61. 히잉.mp3",
    "fileSize": 7869,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/62. 이건너무한거아니냐고.mp3",
    "storageType": "url",
    "fileName": "62. 이건너무한거아니냐고.mp3",
    "fileSize": 24483,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/63. 안녕히계세요여러분.mp3",
    "storageType": "url",
    "fileName": "63. 안녕히계세요여러분.mp3",
    "fileSize": 19154,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/64. 때리는소리.mp3",
    "storageType": "url",
    "fileName": "64. 때리는소리.mp3",
    "fileSize": 5048,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/65. 예~.mp3",
    "storageType": "url",
    "fileName": "65. 예~.mp3",
    "fileSize": 25423,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/66. 상황끝나는 띠딩.mp3",
    "storageType": "url",
    "fileName": "66. 상황끝나는 띠딩.mp3",
    "fileSize": 41903,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/67. 자막용 띵동1.mp3",
    "storageType": "url",
    "fileName": "67. 자막용 띵동1.mp3",
    "fileSize": 24140,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/68. 자막용 띵동2.mp3",
    "storageType": "url",
    "fileName": "68. 자막용 띵동2.mp3",
    "fileSize": 42948,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/69. 자막용띵동3.mp3",
    "storageType": "url",
    "fileName": "69. 자막용띵동3.mp3",
    "fileSize": 35634,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/7. 뿅.mp3",
    "storageType": "url",
    "fileName": "7. 뿅.mp3",
    "fileSize": 11317,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/70. 자막용 따닥.mp3",
    "storageType": "url",
    "fileName": "70. 자막용 따닥.mp3",
    "fileSize": 14736,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/71. 병따는소리1.mp3",
    "storageType": "url",
    "fileName": "71. 병따는소리1.mp3",
    "fileSize": 36679,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/72. 병따는소리2.mp3",
    "storageType": "url",
    "fileName": "72. 병따는소리2.mp3",
    "fileSize": 35634,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/73. 병따는소리3.mp3",
    "storageType": "url",
    "fileName": "73. 병따는소리3.mp3",
    "fileSize": 28319,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/74. 병따는소리4.mp3",
    "storageType": "url",
    "fileName": "74. 병따는소리4.mp3",
    "fileSize": 35634,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/75. 허무1.mp3",
    "storageType": "url",
    "fileName": "75. 허무1.mp3",
    "fileSize": 59666,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/76. 허무2.mp3",
    "storageType": "url",
    "fileName": "76. 허무2.mp3",
    "fileSize": 51307,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/77. 슬쩍.mp3",
    "storageType": "url",
    "fileName": "77. 슬쩍.mp3",
    "fileSize": 33544,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/78. 드럼.mp3",
    "storageType": "url",
    "fileName": "78. 드럼.mp3",
    "fileSize": 48172,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/79. 손짓.mp3",
    "storageType": "url",
    "fileName": "79. 손짓.mp3",
    "fileSize": 48172,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/8. 도망.mp3",
    "storageType": "url",
    "fileName": "8. 도망.mp3",
    "fileSize": 7869,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/80. 돈소리.mp3",
    "storageType": "url",
    "fileName": "80. 돈소리.mp3",
    "fileSize": 56532,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/81. 정답소리.mp3",
    "storageType": "url",
    "fileName": "81. 정답소리.mp3",
    "fileSize": 41903,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/84. 클로징(수고하셨습니다^^).mp3",
    "storageType": "url",
    "fileName": "84. 클로징(수고하셨습니다^^).mp3",
    "fileSize": 36679,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/85. 마리오코인(돈계산).mp3",
    "storageType": "url",
    "fileName": "85. 마리오코인(돈계산).mp3",
    "fileSize": 23747,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/9. 뜨헉.mp3",
    "storageType": "url",
    "fileName": "9. 뜨헉.mp3",
    "fileSize": 12257,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/ㅠㅠ.mp3",
    "storageType": "url",
    "fileName": "ㅠㅠ.mp3",
    "fileSize": 186854,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/두둥탁 효과음.mp3",
    "storageType": "url",
    "fileName": "두둥탁 효과음.mp3",
    "fileSize": 20199,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/따단.mp3",
    "storageType": "url",
    "fileName": "따단.mp3",
    "fileSize": 339827,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/뭐요.mp3",
    "storageType": "url",
    "fileName": "뭐요.mp3",
    "fileSize": 181838,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/삐뿌.mp3",
    "storageType": "url",
    "fileName": "삐뿌.mp3",
    "fileSize": 152581,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/순간이동.mp3",
    "storageType": "url",
    "fileName": "순간이동.mp3",
    "fileSize": 183510,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/쏘옥.mp3",
    "storageType": "url",
    "fileName": "쏘옥.mp3",
    "fileSize": 170971,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/어엉.mp3",
    "storageType": "url",
    "fileName": "어엉.mp3",
    "fileSize": 215275,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/지이잉.mp3",
    "storageType": "url",
    "fileName": "지이잉.mp3",
    "fileSize": 215275,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/큰북두번.mp3",
    "storageType": "url",
    "fileName": "큰북두번.mp3",
    "fileSize": 49071,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/휘두르는 소리.mp3",
    "storageType": "url",
    "fileName": "휘두르는 소리.mp3",
    "fileSize": 186854,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/휙.mp3",
    "storageType": "url",
    "fileName": "휙.mp3",
    "fileSize": 160940,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  },
  {
    "id": "https://pub-7ddc45204a7d4e9c99ae5fb7f5789299.r2.dev/effects/히잉.mp3",
    "storageType": "url",
    "fileName": "히잉.mp3",
    "fileSize": 243696,
    "mimeType": "audio/mpeg",
    "duration": 0,
    "width": 0,
    "height": 0,
    "fps": 0,
    "codec": "unknown",
    "bitrate": 0,
    "tags": [
      "system",
      "sfx",
      "preset"
    ],
    "createdAt": 1700000000000,
    "updatedAt": 1700000000000
  }
];
